/**
 * @generated SignedSource<<fe152d9f91a93b2d23bbdde3773e09ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type YesNoBlank = "blank" | "no" | "yes";
export type employmentSpecialRelationshipsPastQuery$variables = {
  refundHistoryId: string;
};
export type employmentSpecialRelationshipsPastQuery$data = {
  readonly getSurveyEmploymentAnswer: {
    readonly employmentAnswer: {
      readonly hasSpecialRelationshipsInThePast: YesNoBlank;
      readonly specialRelationshipsInThePast: ReadonlyArray<{
        readonly attrYears: ReadonlyArray<string>;
        readonly birthday: string | null | undefined;
        readonly ieNm: string;
        readonly indvTin: string;
      }> | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type employmentSpecialRelationshipsPastQuery = {
  response: employmentSpecialRelationshipsPastQuery$data;
  variables: employmentSpecialRelationshipsPastQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundHistoryId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyEmploymentAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyEmploymentAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyEmploymentAnswer",
        "kind": "LinkedField",
        "name": "employmentAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasSpecialRelationshipsInThePast",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SurveyEmployee",
            "kind": "LinkedField",
            "name": "specialRelationshipsInThePast",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "indvTin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ieNm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attrYears",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "employmentSpecialRelationshipsPastQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "employmentSpecialRelationshipsPastQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8644e68f1184950efb197220ae9a418",
    "id": null,
    "metadata": {},
    "name": "employmentSpecialRelationshipsPastQuery",
    "operationKind": "query",
    "text": "query employmentSpecialRelationshipsPastQuery(\n  $refundHistoryId: String!\n) {\n  getSurveyEmploymentAnswer(refundHistoryId: $refundHistoryId) {\n    result\n    employmentAnswer {\n      hasSpecialRelationshipsInThePast\n      specialRelationshipsInThePast {\n        indvTin\n        ieNm\n        birthday\n        attrYears\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2eca306664d8e4904ee297441fe43e28";

export default node;
